module.exports = __webpack_public_path__ + "media/entities/2040-143c0037.png";